import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles, Check, Clock, Zap, ShoppingCart, Download, FileText, Shield } from 'lucide-react';
const bonusBooks = [{
  id: 1,
  title: 'TU AURA DIGITAL',
  subtitle: 'Proyecta autoridad total desde los primeros 7 segundos',
  image: 'https://cdn.magicpatterns.com/uploads/6JkRrSocAvxHa6XqKWwnEJ/portada_bono_1.png'
}, {
  id: 2,
  title: 'Lenguaje Corporal de Poder',
  subtitle: 'El secreto para vender y cerrar tratos',
  image: 'https://cdn.magicpatterns.com/uploads/b1wzqEovnMiz8AfZu8aofo/portada_bono_2.png'
}, {
  id: 3,
  title: 'Máster de la Voz',
  subtitle: 'Convierte tu voz en una señal de autoridad',
  image: 'https://cdn.magicpatterns.com/uploads/wjuLPxHXYSdYDKAPrUTuZ8/portada_bono_3.png'
}, {
  id: 4,
  title: 'Historias Magnéticas',
  subtitle: 'Sé un líder que inspira, mueve, dirige',
  image: 'https://cdn.magicpatterns.com/uploads/oZAdDorUgZ1P1GGaAn7K3z/imagen_de_portada_bono_4.png'
}, {
  id: 5,
  title: 'Domina el Escenario',
  subtitle: 'Técnicas para brillar bajo presión',
  image: 'https://cdn.magicpatterns.com/uploads/dn8Teu15eP1V5zKj5DQfa9/imagen_de_portada_bono_5.png'
}, {
  id: 6,
  title: 'Arma tu Home Studio Pro',
  subtitle: 'Tu set listo: luz, audio y cámara',
  image: 'https://cdn.magicpatterns.com/uploads/9vN5RQWvquN3se3o2wWsH9/imagen_de_portada_bono_6.png'
}];
export function PremiumPackOffer() {
  return <section className="py-24 bg-gradient-to-b from-black via-[#0a0a0a] to-black text-white relative overflow-hidden" data-id="element-295">
      {/* Ambient glow effects */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#C9A961]/10 rounded-full blur-[120px]" data-id="element-296" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#C9A961]/10 rounded-full blur-[120px]" data-id="element-297" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-298">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-299">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-[#C9A961]/20 border border-[#C9A961] px-6 py-2 rounded-full mb-6" data-id="element-300">
            <Sparkles size={20} className="text-[#C9A961]" data-id="element-301" />
            <span className="font-bold text-[#C9A961] uppercase tracking-wider" data-id="element-302">
              Oferta de Lanzamiento - Tiempo Limitado
            </span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-6xl font-bold mb-6" data-id="element-303">
            PACK EDICIÓN <span className="text-[#C9A961]" data-id="element-304">PREMIUM</span>
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-8" data-id="element-305">
            <p className="text-xl md:text-2xl text-gray-300 mb-4" data-id="element-306">
              Compra el ebook{' '}
              <span className="text-[#C9A961] font-bold" data-id="element-307">
                COMUNICACIÓN MAGNÉTICA
              </span>{' '}
              por solo{' '}
              <span className="text-[#C9A961] font-bold text-3xl" data-id="element-308">$9.95</span>
            </p>
            <p className="text-2xl md:text-3xl text-white font-bold" data-id="element-309">
              y llévate{' '}
              <span className="text-[#C9A961]" data-id="element-310">GRATIS 6 ebooks más</span>
            </p>
            <p className="text-lg text-gray-400 mt-4" data-id="element-311">
              Valor total de los 7 ebooks:{' '}
              <span className="line-through" data-id="element-312">$250.00</span>{' '}
              <span className="text-[#C9A961] font-bold" data-id="element-313">Hoy: $9.95</span>
            </p>
          </motion.div>

          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-314">
            Diseñado para que proyectes autoridad en reuniones, ventas, cámara y
            escenario.
          </p>
        </div>

        {/* Main Book */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto mb-20" data-id="element-315">
          <div className="bg-gradient-to-br from-[#1a1a1a] to-black rounded-3xl p-8 md:p-12 border border-[#C9A961]/30 shadow-2xl" data-id="element-316">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-317">
              <div className="relative" data-id="element-318">
                <div className="absolute inset-0 bg-[#C9A961]/20 blur-[80px]" data-id="element-319" />
                <img src="https://cdn.magicpatterns.com/uploads/b11THbm6qiyoCycrZuyb8M/portada_libro_principal.png" alt="Comunicación Magnética" className="relative w-full max-w-sm mx-auto drop-shadow-2xl" data-id="element-320" />
              </div>

              <div data-id="element-321">
                <div className="inline-block bg-[#C9A961] text-black px-4 py-1 rounded-full text-sm font-bold mb-4" data-id="element-322">
                  EBOOK PRINCIPAL
                </div>
                <h3 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-323">
                  COMUNICACIÓN MAGNÉTICA
                </h3>
                <p className="text-xl text-gray-300 mb-6" data-id="element-324">
                  Tu base. Aprende a hablar con claridad, dirigir conversaciones
                  y convencer sin rogar aprobación.
                </p>
                <ul className="space-y-3" data-id="element-325">
                  {['Sistema IMÁN completo', 'Plantillas copiables', 'Ejercicios prácticos', 'Aplicable desde el día 1'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-300" data-id="element-326">
                      <Check size={20} className="text-[#C9A961] flex-shrink-0" data-id="element-327" />
                      <span data-id="element-328">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Bonus Books Grid */}
        <div className="mb-16" data-id="element-329">
          <div className="flex items-center justify-center gap-3 mb-12" data-id="element-330">
            <Gift size={32} className="text-[#C9A961]" data-id="element-331" />
            <h3 className="text-3xl md:text-4xl font-bold" data-id="element-332">
              + 6 BONOS <span className="text-[#C9A961]" data-id="element-333">GRATIS</span>
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-334">
            {bonusBooks.map((book, index) => <motion.div key={book.id} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-gradient-to-br from-[#1a1a1a] to-black rounded-2xl p-6 border border-[#C9A961]/20 hover:border-[#C9A961]/50 transition-all duration-300" data-id="element-335">
                <div className="flex items-center gap-2 mb-4" data-id="element-336">
                  <div className="bg-[#C9A961] text-black w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-337">
                    {book.id}
                  </div>
                  <span className="text-xs text-[#C9A961] font-bold uppercase tracking-wider" data-id="element-338">
                    Bono {book.id}
                  </span>
                </div>

                {book.image ? <img src={book.image} alt={book.title} className="w-full h-64 object-cover rounded-lg mb-4 shadow-lg" data-id="element-339" /> : <div className="w-full h-64 bg-gradient-to-br from-[#2a2a2a] to-[#1a1a1a] rounded-lg mb-4 flex items-center justify-center border border-[#C9A961]/20" data-id="element-340">
                    <span className="text-gray-600 text-sm" data-id="element-341">
                      Portada próximamente
                    </span>
                  </div>}

                <h4 className="text-xl font-bold mb-2" data-id="element-342">{book.title}</h4>
                <p className="text-gray-400 text-sm" data-id="element-343">{book.subtitle}</p>
              </motion.div>)}
          </div>
        </div>

        {/* Value Proposition - Para quién es */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto bg-gradient-to-br from-[#C9A961]/10 to-transparent rounded-3xl p-8 md:p-12 border border-[#C9A961]/30 mb-16" data-id="element-344">
          <h3 className="text-2xl md:text-3xl font-bold mb-8 text-center" data-id="element-345">
            ¿Para quién es este pack?
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-346">
            <div data-id="element-347">
              <h4 className="text-xl font-bold text-[#C9A961] mb-4 flex items-center gap-2" data-id="element-348">
                <Check size={24} data-id="element-349" /> Es para ti si:
              </h4>
              <ul className="space-y-4 text-gray-300" data-id="element-350">
                {['Vendes por llamadas, Zoom, WhatsApp o reuniones', 'Lideras equipo, proyectos o clientes', 'Creas contenido, cursos o asesorías', 'Quieres sonar y verte con autoridad sin actuar ni fingir'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-351">
                    <span className="text-[#C9A961] mt-1" data-id="element-352">•</span>
                    <span data-id="element-353">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-354">
              <h4 className="text-xl font-bold text-red-400 mb-4 flex items-center gap-2" data-id="element-355">
                <span className="text-xl" data-id="element-356">✗</span> No es para ti si:
              </h4>
              <ul className="space-y-4 text-gray-300" data-id="element-357">
                {['Buscas "motivación" sin práctica', 'No quieres aplicar ejercicios (esto es entrenamiento)'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-358">
                    <span className="text-red-400 mt-1" data-id="element-359">•</span>
                    <span data-id="element-360">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Lo que vas a notar rápido */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto mb-16" data-id="element-361">
          <div className="text-center mb-10" data-id="element-362">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#C9A961]/20 mb-4" data-id="element-363">
              <Zap size={32} className="text-[#C9A961]" data-id="element-364" />
            </div>
            <h3 className="text-3xl md:text-4xl font-bold" data-id="element-365">
              Lo que vas a notar rápido
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-366">
            {['Hablas más corto, más claro y con más impacto.', 'Tu cuerpo acompaña tu mensaje (sin nervios visibles).', 'Tu voz suena firme incluso cuando te presionan.', 'Cuentas historias que generan atención y respeto.', 'En cámara te ves profesional sin gastar de más.'].map((item, index) => <div key={index} className={`bg-[#1a1a1a] p-6 rounded-xl border border-[#C9A961]/20 flex items-start gap-4 ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-367">
                <div className="bg-[#C9A961]/20 p-2 rounded-full mt-1" data-id="element-368">
                  <Check size={16} className="text-[#C9A961]" data-id="element-369" />
                </div>
                <p className="text-lg text-gray-200" data-id="element-370">{item}</p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}